// extracted by mini-css-extract-plugin
module.exports = {"container":"TutorialsPopup_container__ExI5C","headline":"TutorialsPopup_headline__3PrCW","tutorial":"TutorialsPopup_tutorial__2BPIq","loader":"TutorialsPopup_loader__XJSKB"};